import { CreateField, Field, UpdateField } from "@/types/breeze/Field";
import { BaseService } from "../BaseService";

export class FieldService extends BaseService {
  public async getAllByEntityName(entityName: string): Promise<Field[]> {
    return this.getRequest(`/entities/${entityName}/fields`);
  }

  public async createField(
    entityName: string,
    field: CreateField,
  ): Promise<Field> {
    return this.postRequest(
      `/entities/${entityName}/fields`,
      field,
      "Field created",
    );
  }

  public async updateField(
    entityName: string,
    fieldId: number,
    field: UpdateField,
    suppressSuccessMessage: boolean = false,
  ): Promise<Field> {
    return this.putRequest(
      `/entities/${entityName}/fields/${fieldId}`,
      field,
      "Field updated",
      true,
      suppressSuccessMessage,
    );
  }

  public async deleteField(entityName: string, fieldId: number): Promise<void> {
    return this.deleteRequest(
      `/entities/${entityName}/fields/${fieldId}`,
      "Field deleted",
    );
  }

  public async reorderFields(
    entityName: string,
    updates: { field_id: number; sort_order: number }[],
  ): Promise<void> {
    return this.putRequest(
      `/entities/${entityName}/fields/reorder`,
      updates,
      "",
      true,
      true,
    );
  }
}

export const fieldService = new FieldService();
